import ContentfulImageRenderer from 'contentful/image_renderer';
import MediaCaption from 'contentful/media_caption';

const BlogPostHero = ({ heroImage }) =>
  !!Object.keys(heroImage || {}).length && (
    <div className="blog-post__hero__banner mb-22">
      <ContentfulImageRenderer image={heroImage} />
      {heroImage?.fields.description && (
        <MediaCaption>{heroImage.fields.description}</MediaCaption>
      )}
    </div>
  );

export default BlogPostHero;
